module.exports = __webpack_public_path__ + "img/ASO_fr24.14b8a903.png";